/*
  Cãomigo — motor das páginas de produto (tema Shopify).
  Corre a mesma lógica das páginas do Claude Design (classe Component de cada produto)
  com um DCLogic mínimo: setState -> renderVals -> atualiza o DOM marcado com
    data-bt-<atributo>="texto com [[caminho]]"   (atributo ligado)
    data-bx="caminho"                             (texto ligado)
    data-bif="caminho"                            (mostra/esconde)
    data-on="evento:caminho;..."                  (eventos)
    data-ref="caminho"                            (ref, chamado 1 vez)
  O carrinho é real: /cart/add.js + evento CartLinesUpdate do tema (abre a gaveta).
*/
(function () {
  'use strict';

  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (u, cb) {
    var upd = typeof u === 'function' ? u(this.state, this.props) : u;
    this.state = Object.assign({}, this.state, upd || {});
    if (cb) (this.__cbs || (this.__cbs = [])).push(cb);
    if (this.__schedule) this.__schedule();
  };
  window.DCLogic = DCLogic;

  function get(o, path) {
    var ks = path.split('.');
    for (var i = 0; i < ks.length; i++) { if (o == null) return undefined; o = o[ks[i]]; }
    return o;
  }
  function fill(tpl, vals) {
    return tpl.replace(/\[\[([^\]]+)\]\]/g, function (m, p) {
      var v = get(vals, p.trim());
      return v == null || typeof v === 'function' ? '' : String(v);
    }).replace(/\s+/g, ' ').trim();
  }

  var CMG = window.CMG = window.CMG || {};
  CMG.pages = CMG.pages || {};

  /* ---------- carrinho ---------- */
  /* Os eventos do carrinho do Horizon vêm de @shopify/events. Um import() aqui não serve: o CDN da
     Shopify transforma este ficheiro e troca-o por require(), que não existe no browser (26-09-2026).
     Por isso a secção carrega o módulo num <script type="module"> e deixa-o em window.CMGEvents. */
  var eventsMod = null;
  function loadEvents() {
    if (!eventsMod) eventsMod = new Promise(function (resolve) {
      var n = 0;
      (function espera() {
        if (window.CMGEvents && window.CMGEvents.CartLinesUpdateEvent) return resolve(window.CMGEvents);
        if (++n > 60) return resolve(null);
        setTimeout(espera, 50);
      })();
    });
    return eventsMod;
  }
  CMG.cartAdd = function (variantId, qty, sourceEl) {
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    if (!/\.js$/.test(addUrl)) addUrl += '.js';
    var cartUrl = (routes.cart_url || '/cart') + '.json';
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty || 1));
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
    if (ids.length) fd.append('sections', ids.join(','));

    return loadEvents().then(function (mod) {
      var Ev = mod && mod.CartLinesUpdateEvent;
      var deferred = Ev ? Ev.createPromise() : null;
      if (Ev) {
        (sourceEl || document).dispatchEvent(new Ev({
          action: 'add', context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: qty || 1 }],
          promise: deferred.promise
        }));
      }
      return fetch(addUrl, {
        method: 'POST', body: fd,
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'Erro ao adicionar');
        return fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (Ev) {
            deferred.resolve({
              cart: Ev.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'caomigo-produto', itemCount: qty || 1, sections: res.sections, didError: false }
            });
          }
          CMG.bumpCart(cart.item_count);
          return { cart: cart, hasEvents: !!Ev };
        });
      }).catch(function (err) {
        if (deferred) deferred.reject(err);
        throw err;
      });
    });
  };
  CMG.openDrawer = function () {
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (d && typeof d.open === 'function' && !d.isOpen) { try { d.open(); } catch (e) {} }
    else if (!d) window.location.href = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart');
  };
  CMG.bumpCart = function () {
    document.querySelectorAll('.header-actions__cart-icon .cart-bubble, .cart-bubble').forEach(function (b) {
      b.classList.remove('cmg-bump'); void b.offsetWidth; b.classList.add('cmg-bump');
      setTimeout(function () { b.classList.remove('cmg-bump'); }, 500);
    });
  };

  /* ---------- montagem ---------- */
  function mount(root) {
    var key = root.getAttribute('data-cmg-page');
    var Comp = CMG.pages[key];
    if (!Comp || root.__cmg) return;
    var c = new Comp({});
    root.__cmg = c;
    var ds = root.dataset;

    // estado inicial vindo do Shopify
    if (ds.corInicial && c.state && 'cor' in c.state) c.state.cor = ds.corInicial;

    // variante escolhida (Taça: pela cor)
    var variantInput = root.querySelector('[data-cmg-variant]');
    c.__variantId = function () {
      if (ds.varVerde && ds.varPreto && c.state && c.state.cor) return c.state.cor === 'preto' ? ds.varPreto : ds.varVerde;
      return variantInput ? variantInput.value : ds.variant;
    };

    // "Adicionar ao carrinho" a sério
    var origAdd = c.add, origPar = c.addPar;
    c.add = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      if (c.__busy || ds.available === 'false') return;
      c.__busy = true;
      CMG.cartAdd(c.__variantId(), 1, root).then(function (r) {
        origAdd.call(c);
        setTimeout(function () { CMG.openDrawer(); }, r && r.hasEvents ? 650 : 0);
      }).catch(function () {
        c.setState({ live: 'Não foi possível adicionar ao carrinho. Tenta outra vez.' });
      }).then(function () { c.__busy = false; });
    };
    c.addPar = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      if (c.state.par || c.__busyPar || !ds.parVariant) return;
      c.__busyPar = true;
      CMG.cartAdd(ds.parVariant, 1, root).then(function () {
        origPar.call(c);
      }).catch(function () {
        c.setState({ live: 'Não foi possível adicionar ao carrinho. Tenta outra vez.' });
      }).then(function () { c.__busyPar = false; });
    };

    // Taça: mudar a cor muda também a variante do formulário
    ['corVerde', 'corPreto'].forEach(function (k) {
      if (typeof c[k] !== 'function') return;
      var o = c[k];
      c[k] = function (e) {
        o.call(c, e);
        if (variantInput) variantInput.value = c.__variantId();
        try {
          var u = new URL(window.location.href); u.searchParams.set('variant', c.__variantId());
          window.history.replaceState({}, '', u);
        } catch (x) {}
      };
    });

    var soldOut = ds.available === 'false';
    var vals = {};
    var bt = [], bx = [], bif = [];
    root.querySelectorAll('*').forEach(function (el) {
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        if (a.name.indexOf('data-bt-') === 0) bt.push([el, a.name.slice(8), a.value]);
      }
    });
    root.querySelectorAll('[data-bx]').forEach(function (el) { bx.push([el, el.getAttribute('data-bx')]); });
    root.querySelectorAll('[data-bif]').forEach(function (el) { bif.push([el, el.getAttribute('data-bif')]); });

    function render() {
      vals = c.renderVals();
      if (soldOut) { vals.ctaLabel = 'Esgotado'; vals.ctaShort = 'Esgotado'; }
      for (var i = 0; i < bt.length; i++) {
        var el = bt[i][0], name = bt[i][1], v = fill(bt[i][2], vals);
        if (name === 'class') { if (el.getAttribute('class') !== v) el.setAttribute('class', v); }
        else if (name === 'value') { if (String(el.value) !== v) el.value = v; }
        else if (el.getAttribute(name) !== v) el.setAttribute(name, v);
      }
      for (var j = 0; j < bx.length; j++) {
        var t = get(vals, bx[j][1]); t = t == null ? '' : String(t);
        if (bx[j][0].textContent !== t) bx[j][0].textContent = t;
      }
      for (var k = 0; k < bif.length; k++) bif[k][0].hidden = !get(vals, bif[k][1]);
      var cbs = c.__cbs; c.__cbs = null;
      if (cbs) cbs.forEach(function (f) { try { f(); } catch (e) { console.error(e); } });
    }
    var raf = 0;
    c.__schedule = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; render(); }); };

    // eventos (resolvidos no momento, a partir dos valores atuais)
    root.querySelectorAll('[data-on]').forEach(function (el) {
      el.getAttribute('data-on').split(';').forEach(function (pair) {
        var p = pair.split(':'); if (p.length < 2) return;
        var ev = p[0], path = p[1];
        el.addEventListener(ev, function (e) {
          if (ev === 'click' && (el.type === 'submit' || el.tagName === 'A')) e.preventDefault();
          var fn = get(vals, path);
          if (typeof fn === 'function') fn(e);
        });
      });
    });

    render();
    // refs
    root.querySelectorAll('[data-ref]').forEach(function (el) {
      var fn = get(vals, el.getAttribute('data-ref'));
      if (typeof fn === 'function') fn(el);
    });
    if (typeof c.componentDidMount === 'function') c.componentDidMount();
    render();
    root.classList.add('cmg-ready');
  }

  function start() { document.querySelectorAll('[data-cmg-page]').forEach(mount); }
  CMG.mount = mount;
  CMG.mountAll = function () { if (document.readyState !== 'loading') start(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
